import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=9b58492e&"
import script from "./AdminMain.vue?vue&type=script&lang=js&"
export * from "./AdminMain.vue?vue&type=script&lang=js&"
import style0 from "./AdminMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports